module.exports = __webpack_public_path__ + "media/קן.80ad0c09.mp3";